// Module
var code = "<div>\n\n  <section class=\"heading\">\n    <div class=\"row no-gutter\">\n      <ng-include src=\"'/dashboard/nav.html'\"></ng-include>\n    </div>\n\n  </section>\n\n  <reservations-dashboard user=\"user\" on-error=\"onError\" />\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/dashboard/reservations.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;